export interface AuthState {
  user: any | null;
}

export const initialAuthState: AuthState = {
  user: null
};
